<template>
  <div>
    <v-progress-circular
      :size="50"
      color="#1abc9c"
      indeterminate
      v-if="loading"
    ></v-progress-circular>
    <Toolbar v-if="showToolbar" :title="toolbarTitle"></Toolbar>
    <v-form
      v-if="!loading"
      @submit.prevent
      ref="form"
      v-model="form.valid"
      lazy-validation
    >
      <v-container>
        <v-row>
          <v-col :cols="12" :sm="12">
            <v-text-field
              v-model="form.name"
              label="Name"
              required
            ></v-text-field>
          </v-col>
          <v-col :cols="6">
            <v-select
              :items="categories"
              v-model="form.category"
              item-text="text"
              item-value="id"
              label="Category"
            >
              <template v-slot:selection="data">
                <!-- HTML that describe how select should render selected items -->
                {{ data.item.text }}
              </template>
              <template v-slot:item="data">
                <!-- HTML that describe how select should render items when the select is open -->
                <div>{{ data.item.text }}</div>
                <div class="category-delete">
                  <v-icon
                    @click="deleteCategory(data.item)"
                    color="grey lighten-1"
                    >mdi-delete</v-icon
                  >
                </div>
              </template>
            </v-select>
          </v-col>
          <v-col :cols="6">
            <button @click="openCreateCategoryModal" class="button">
              Add category
            </button>
          </v-col>
          <v-col :cols="6">
            <v-text-field
              v-model="form.quantity"
              type="number"
              label="Quantity"
            ></v-text-field>
          </v-col>
          <v-col :cols="6">
            <v-text-field v-model="form.unit" label="Unit"></v-text-field>
          </v-col>
          <v-col :cols="12">
            <v-textarea v-model="form.note" label="Notes"></v-textarea>
          </v-col>
          <transition name="fade">
            <v-col :cols="12" v-if="showSuccessMessage">
              <div
                class="success-message-container"
                v-text="'Item added'"
              ></div>
            </v-col>
          </transition>
          <v-col>
            <button
              @click="addOrUpdateItem"
              v-text="isUpdate ? 'Update item' : 'Add item'"
              class="button"
            ></button>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <transition name="fade">
      <div v-if="showCreateCategoryModal" class="create-modal">
        <div class="create-container">
          <a @click="closeCreateCategoryModal">Close</a>
          <p>Add category</p>
          <v-form
            @submit.prevent
            ref="categoryForm"
            v-model="categoryForm.valid"
            lazy-validation
          >
            <v-text-field
              v-model="categoryForm.name"
              placeholder="Name"
              required
            ></v-text-field>
            <div v-if="categoryForm.icon" class="selected-emoji">
              Selected icon: {{ categoryForm.icon }}
            </div>
            <VEmojiPicker @select="selectEmoji" />
            <v-btn
              color="#1abc9c"
              dark
              big
              fixed
              bottom
              right
              fab
              @click="addCategory"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
          </v-form>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Toolbar from "./ListItemToolbar";
import VEmojiPicker from "v-emoji-picker";
import firebase from "firebase";
const fb = require("../firebaseConfig.js");

export default {
  name: "ListItem",
  components: {
    Toolbar,
    VEmojiPicker
  },
  data() {
    return {
      unsubscribeListener: null,
      showCreateCategoryModal: false,
      loading: false,
      showToolbar: false,
      showSuccessMessage: false,
      successMessage: "",
      isUpdate: false,
      listId: "",
      listItemId: "",
      listItem: null,
      toolbarTitle: "",
      categories: [],
      form: {
        valid: false,
        name: "",
        category: "",
        quantity: "",
        unit: "",
        note: ""
      },
      categoryForm: {
        valid: false,
        name: "",
        icon: null
      }
    };
  },
  methods: {
    addCategory() {
      let category = {
        list_id: this.listId,
        name: this.categoryForm.name,
        icon: this.categoryForm.icon ? this.categoryForm.icon : ""
      };

      fb.listItemsCategoriesCollection
        .add(category)
        .then(doc => {
          this.form.category = doc.id;
          this.closeCreateCategoryModal();
        })
        .catch(err => {
          console.log(err);
        });
    },
    deleteCategory(category) {
      if (!confirm("Are you sure you want to delete this category?")) {
        return;
      }
      fb.listItemsCategoriesCollection.doc(category.id).delete();
    },
    openCreateCategoryModal() {
      this.showCreateCategoryModal = true;
    },
    closeCreateCategoryModal() {
      this.categoryForm.name = "";
      this.categoryForm.icon = null;
      this.showCreateCategoryModal = false;
    },
    selectEmoji(emoji) {
      this.categoryForm.icon = emoji.data;
    },
    fetchListItem() {
      this.unsubscribeListener = fb.listItemsCategoriesCollection
        .where("list_id", "==", this.listId)
        .orderBy("name")
        .onSnapshot(
          querySnapshot => {
            this.categories = [];
            if (querySnapshot.size > 0) {
              querySnapshot.forEach(doc => {
                let category = {
                  id: doc.id,
                  name: doc.data().name,
                  icon: doc.data().icon,
                  text: doc.data().icon + " " + doc.data().name
                };
                this.categories.push(category);
              });
            }
            if (this.listItemId !== "0") {
              fb.distinctListItemsCollection
                .doc(this.listItemId)
                .get()
                .then(doc => {
                  if (doc.exists) {
                    this.listItem = doc.data();
                    this.toolbarTitle = this.listItem.name;
                    this.form.name = this.listItem.name;
                    this.form.category = this.form.category
                      ? this.form.category
                      : this.listItem.category_id;
                    this.form.quantity = this.listItem.quantity;
                    this.form.unit = this.listItem.unit;
                    this.form.note = this.listItem.note;
                  } else {
                    this.toolbarTitle = "Add item to list";
                  }

                  this.showToolbar = true;
                  this.loading = false;
                })
                .catch(err => {
                  console.log(err);
                  this.loading = false;
                });
            } else {
              this.showToolbar = true;
              this.loading = false;
            }
          },
          function(error) {
            console.log(error);
            this.loading = false;
          }
        );
    },
    addOrUpdateItem() {
      this.showSuccessMessage = false;
      if (this.listItemId === "0") this.addItem();
      else this.updateItem();
    },
    addItem() {
      let newDistinctItem = {
        isBought: false,
        list_id: this.listId,
        name: this.form.name,
        category_id: this.form.category ? this.form.category : "0",
        quantity: this.form.quantity ? this.form.quantity : "",
        unit: this.form.unit ? this.form.unit : "",
        note: this.form.note ? this.form.note : ""
      };
      fb.distinctListItemsCollection
        .add(newDistinctItem)
        .then(distinctItem => {
          fb.userListsCollection
            .where("list_id", "==", this.listId)
            .get()
            .then(snap => {
              if (snap.size > 0) {
                fb.listsCollection
                  .doc(this.listId)
                  .update({
                    total_items: firebase.firestore.FieldValue.increment(1)
                  })
                  .then(() => {
                    snap.forEach(doc => {
                      let newItem = {
                        isBought: false,
                        list_id: this.listId,
                        distinct_item_id: distinctItem.id,
                        user_list_id: doc.id,
                        name: this.form.name,
                        category_id: this.form.category
                          ? this.form.category
                          : "0",
                        quantity: this.form.quantity ? this.form.quantity : "",
                        unit: this.form.unit ? this.form.unit : "",
                        note: this.form.note ? this.form.note : ""
                      };

                      fb.listItemsCollection
                        .add(newItem)
                        .then(() => {
                          fb.userListsCollection.doc(doc.id).update({
                            total_items: firebase.firestore.FieldValue.increment(
                              1
                            )
                          });
                        })
                        .catch(err => {
                          console.log(err);
                        });
                    });

                    this.showSuccessMessage = true;
                    this.form.name = "";
                    this.form.category = "";
                    this.form.quantity = "";
                    this.form.unit = "";
                    this.form.note = "";
                  });
              }
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(err => {
          console.log(err);
        });
    },
    updateItem() {
      fb.distinctListItemsCollection
        .doc(this.listItemId)
        .update({
          name: this.form.name,
          category_id: this.form.category,
          quantity: this.form.quantity ? this.form.quantity : "",
          unit: this.form.unit ? this.form.unit : "",
          note: this.form.note ? this.form.note : ""
        })
        .then(() => {
          fb.listItemsCollection
            .where("distinct_item_id", "==", this.listItemId)
            .get()
            .then(response => {
              let batch = fb.db.batch();
              response.docs.forEach(doc => {
                let updatedItem = {
                  name: this.form.name,
                  category_id: this.form.category,
                  quantity: this.form.quantity ? this.form.quantity : "",
                  unit: this.form.unit ? this.form.unit : "",
                  note: this.form.note ? this.form.note : ""
                };
                const docRef = fb.listItemsCollection.doc(doc.id);
                batch.update(docRef, updatedItem);
              });
              batch.commit().then(() => {
                this.$router.back();
              });
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  created() {
    this.loading = true;
    this.listId = this.$route.params.list_id;
    this.listItemId = this.$route.params.id;
    this.fetchListItem();
    if (this.listItemId !== "0") {
      this.isUpdate = true;
    } else this.toolbarTitle = "Add item to list";
  },
  destroyed() {
    this.unsubscribeListener();
  }
};
</script>

<style scoped lang="scss">
@import "../assets/scss/_global.scss";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.success-message-container {
  background-color: $success;
  padding: 15px;
  color: #fff;
}

.selected-emoji {
  font-size: 20px;
}

.create-modal {
  top: -15%;
}

.category-delete {
  position: absolute;
  right: 10px;
}
</style>
